// view-regimen page: modals are included in view-regimen.js

'use strict';

let $body = $('body');

// close modal
$('.js-collapse-form-modal').on('click', function (e) {
    e.preventDefault();

    let $this = $(this),
    $modal = $this.closest('.form-modal');

    $body.removeClass('fixed');

    $modal.slideUp({
        duration: 500,
        easing: 'easeOutExpo',
        queue: false
    });
});